<template>
	<div id="application-container">
		<v-header></v-header>

		<main class="container">
			<v-loading v-show="loading"></v-loading>
			<transition name="slide">
				<router-view class="view-container"></router-view>
			</transition>
		</main>

		<v-footer></v-footer>
	</div>
</template>

<script>
	import $ from 'jquery';
	import VHeader from 'views/commons/header.vue';
	import VFooter from 'views/commons/footer.vue';
	import VLoading from 'components/loading.vue';

	export default {
		components: { VHeader, VFooter, VLoading },

		data() {
			return {
				loading: false
			};
		},

		created() {
			let timeout;

			$(document)
				.ajaxStart(() => {
					timeout = setTimeout(() => {
						this.loading = true;
					}, 1000);
				})
				.ajaxStop(() => {
					clearTimeout(timeout);
					this.loading = false;
				});
		}
	};
</script>

<style src="assets/css/main.css"></style>

<style scoped>
	.view-container {
		transition: all .2s;
	}

	.slide-enter-active, .slide-leave-active {
		opacity: 0;
		transform: translate(50%, 0);
	}

	.slide-enter, .slide-leave-to {
		opacity: 0;
		transform: translate(-50%, 0);
	}
</style>


// WEBPACK FOOTER //
// main.vue?281975da